export const labelKeys = {
    projectLabels: 'labels/byProject',
    testCaseLabels: 'labels/byTestCase',
    searchLabel: 'labels/search',
};
